"use client"
import Ad from 'src/components/ads/Ad';
import FinishedQuiz from 'src/components/filmquiz/FinishedQuiz';
import Intro from 'src/components/filmquiz/Intro';
import Lives from 'src/components/filmquiz/Lives';
import NextQuestionButton from 'src/components/filmquiz/NextQuestionButton';
import Question from 'src/components/filmquiz/Question';
import ShowAnswer from 'src/components/filmquiz/ShowAnswer';
import TryAgain from 'src/components/filmquiz/TryAgain';
import LoadingIndicator from 'src/components/loadingindicator/LoadingIndicator';
import theme from 'src/components/themes/DefaultTheme';
import useFilmQuiz from 'src/lib/client/useFilmQuiz';
import AdWrapper from 'src/lib/contexts/AdContext';
import styled from 'src/lib/styles/css';

//#region [Props]
type QuizProps = {
};
//#endregion

//#region [Component]
export default function Quiz({ }: QuizProps) {
	const {
		isLoading,
		question,
		nextQuestion,
		doCorrectAnswer,
		doWrongAnswer,
		newQuiz,
		questionNumber,
		livesLeft,
		numCorrect,
		isCurrentQuestionAnswered,
		isCurrentQuestionCorrect
	} = useFilmQuiz();

	return (
        <SFilmquiz>
            {questionNumber > 0 && questionNumber % 3 === 0 && <AdWrapper ads={ADS}>
                <SAd targetId='FW_topp_quiz' removeIfNoAd supportsFixedAd />
            </AdWrapper>}
            {questionNumber === 0 && <Intro doStartQuiz={nextQuestion} />}

            <MainQuizArea>
                {isLoading && <LoadingIndicator position='InlineCenter' size='large' />}
                {questionNumber > 0 && !isLoading && question && <Question
                    qNum={questionNumber}
                    question={question!}
                    doCorrectAnswer={doCorrectAnswer}
                    doWrongAnwer={doWrongAnswer}
                    isAnswered={isCurrentQuestionAnswered}
                />}
                {isCurrentQuestionAnswered && !isLoading && <ShowAnswer isCorrectAnswer={isCurrentQuestionCorrect!} question={question!} />}
                {livesLeft === 0 && <FinishedQuiz questionNumber={questionNumber} />}
            </MainQuizArea>

            {questionNumber > 0 && livesLeft > 0 &&
                <Lives livesLeft={livesLeft} />
            }

            {isCurrentQuestionAnswered && livesLeft > 0 && <NextQuestionButton doNextQuestion={nextQuestion} />}

            {livesLeft === 0 && <TryAgain newQuiz={newQuiz} numCorrect={numCorrect} />}
	    </SFilmquiz>
    );
}
//#endregion

//#region [Styles]
const SFilmquiz = styled.section`
	color: var(--textcolor);
	font-size: 20px;
	text-align: center;
	padding-top: 20px;
	padding-left: 10px;
	padding-right: 10px;
	margin-bottom: 30px;

	@media ${theme.mq.desktop} {
		//@media  (orientation: landscape) {
		padding-left: 0;
		padding-right: 0;
	}
`;


const MainQuizArea = styled.section`
    background: ${theme.palette.lillaHovedfarge};
    border-radius: 20px;
    padding: 1px;
    margin-bottom: 20px;
`;

const SAd = styled(Ad)`
	margin-top: 10px;
	margin-bottom: 30px;
`;
//#endregion

const ADS = [
	{ auId: '00000000000eb992', auW: '2000', auH: '300', targetId: 'FW_topp_quiz' }
];